module["exports"] = [
  "0.#.#",
  "0.##",
  "#.##",
  "#.#",
  "#.#.#"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/app/version.js
// module id = 621
// module chunks = 0